var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.254,
    height: 49.662,
    viewBox: "0 0 43.254 49.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".al{fill:none;}.bl{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.801 4.005)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M136,48h5.607v4.806H136Z",
    transform: "translate(-127.189 -48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M136,128h5.607v4.806H136Z",
    transform: "translate(-127.189 -119.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M113.345,204,104,200h8.01Z",
    transform: "translate(-98.393 -184.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M221.607,338.4h2.4v3.2h-2.4v2.4h-3.2v-2.4H216v-3.2h2.4V336h3.2Z",
    transform: "translate(-199.179 -307.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M63.219,204.806l-.267-.8-1.335-4H48v29.637H89.652V204.806Zm5.607,20.025a7.209,7.209,0,1,1,7.209-7.209,7.209,7.209,0,0,1-7.209,7.209Z",
    transform: "translate(-48 -184.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M72,160h3.2v4H72Z",
    transform: "translate(-69.597 -148.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M408,160h3.2v8.811H408Z",
    transform: "translate(-371.955 -148.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M224.01,338.4v3.2h-2.4v2.4h-3.2v-2.4H216v-3.2h2.4V336h3.2v2.4Z",
    transform: "translate(-199.179 -307.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M136,48h5.607v4.806H136Z",
    transform: "translate(-127.189 -48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M136,128h5.607v4.806H136Z",
    transform: "translate(-127.189 -119.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M224.01,338.4v3.2h-2.4v2.4h-3.2v-2.4H216v-3.2h2.4V336h3.2v2.4Z",
    transform: "translate(-199.179 -307.164)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M82.453,31.229h-1.6v-8.01a.8.8,0,0,0-.8-.8h-2.4V8.8a.8.8,0,0,0-.8-.8H46.408a.8.8,0,0,0-.8.8V22.418H43.2a.8.8,0,0,0-.8.8v3.2H40.8a.8.8,0,0,0-.8.8V56.861a.8.8,0,0,0,.8.8H82.453a.8.8,0,0,0,.8-.8V32.03A.8.8,0,0,0,82.453,31.229ZM77.647,24.02h1.6v7.209h-1.6ZM47.209,9.6H76.045V31.229H56.6l-1.42-4.258a.8.8,0,0,0-.76-.548H47.209ZM44,24.02h1.6v2.4H44ZM81.652,56.06H41.6V28.025H53.84l1.42,4.258a.8.8,0,0,0,.76.548H81.652Z",
    transform: "translate(-40 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M215.209,330.4v-1.6a.8.8,0,0,0-.8-.8h-3.2a.8.8,0,0,0-.8.8v1.6h-1.6a.8.8,0,0,0-.8.8v3.2a.8.8,0,0,0,.8.8h1.6v1.6a.8.8,0,0,0,.8.8h3.2a.8.8,0,0,0,.8-.8v-1.6h1.6a.8.8,0,0,0,.8-.8v-3.2a.8.8,0,0,0-.8-.8Zm.8,3.2h-1.6a.8.8,0,0,0-.8.8v1.6H212v-1.6a.8.8,0,0,0-.8-.8h-1.6V332h1.6a.8.8,0,0,0,.8-.8v-1.6h1.6v1.6a.8.8,0,0,0,.8.8h1.6Z",
    transform: "translate(-191.179 -295.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M184.01,296a8.01,8.01,0,1,0,8.01,8.01A8.01,8.01,0,0,0,184.01,296Zm0,14.418a6.408,6.408,0,1,1,6.408-6.408A6.408,6.408,0,0,1,184.01,310.418Z",
    transform: "translate(-162.383 -267.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M128.8,46.408h5.607a.8.8,0,0,0,.8-.8V40.8a.8.8,0,0,0-.8-.8H128.8a.8.8,0,0,0-.8.8v4.806A.8.8,0,0,0,128.8,46.408Zm.8-4.806h4v3.2h-4Z",
    transform: "translate(-119.189 -36.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M208.8,41.6h16.02a.8.8,0,1,0,0-1.6H208.8a.8.8,0,0,0,0,1.6Z",
    transform: "translate(-191.179 -36.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M208.8,65.6h16.02a.8.8,0,0,0,0-1.6H208.8a.8.8,0,0,0,0,1.6Z",
    transform: "translate(-191.179 -58.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M208.8,89.6h9.612a.8.8,0,1,0,0-1.6H208.8a.8.8,0,0,0,0,1.6Z",
    transform: "translate(-191.179 -79.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M328.8,88a.8.8,0,0,0,0,1.6h1.6a.8.8,0,1,0,0-1.6Z",
    transform: "translate(-299.164 -79.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M128.8,126.408h5.607a.8.8,0,0,0,.8-.8V120.8a.8.8,0,0,0-.8-.8H128.8a.8.8,0,0,0-.8.8v4.806A.8.8,0,0,0,128.8,126.408Zm.8-4.806h4v3.2h-4Z",
    transform: "translate(-119.189 -108.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M208.8,121.6h16.02a.8.8,0,1,0,0-1.6H208.8a.8.8,0,0,0,0,1.6Z",
    transform: "translate(-191.179 -108.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M208.8,145.6h16.02a.8.8,0,1,0,0-1.6H208.8a.8.8,0,0,0,0,1.6Z",
    transform: "translate(-191.179 -130.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M208.8,169.6h9.612a.8.8,0,1,0,0-1.6H208.8a.8.8,0,0,0,0,1.6Z",
    transform: "translate(-191.179 -151.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M330.4,168h-1.6a.8.8,0,0,0,0,1.6h1.6a.8.8,0,1,0,0-1.6Z",
    transform: "translate(-299.164 -151.98)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.6262f2df.svg";
export { ForwardRef as ReactComponent };